import { Config } from 'final-form'
import { Component } from 'vue-property-decorator'

import { MovementTypes } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { BarcodeReader, Field, Form } from '@skinsoft/ui'
import { LocationSelector } from '@skinsoft/entity-ui'

export interface Values {
    location: string;
    permanentLocation?: boolean;
    usePermanentLocItemAsDestination?: boolean;
}

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
        sLocationSelector: LocationSelector
    },
    props: ['onSubmit', 'initialValues', 'movementType'],
    template: require('./close-form.html'),
})
export class CloseForm extends ReactiveVue {
    public onSubmit: Config['onSubmit'];
    public initialValues: Values;
    public movementType: MovementTypes;

    public MovementTypes = MovementTypes;

    public $refs: {
        barcodeReader: BarcodeReader;
        form: Form;
        location: Field;
    };

    private isLocationSelected = false;
    private usePermanentLocItemAsDestination: boolean | undefined

    private mounted() {
        this.usePermanentLocItemAsDestination = this.initialValues.usePermanentLocItemAsDestination
    }

    public validate(values): Promise<object> {
        return new Promise(resolve => {
            this.usePermanentLocItemAsDestination = values.usePermanentLocItemAsDestination
            // need to be a promise to avoid conflict with $t mixin
            const errors = {} as any;

            if (this.movementType === MovementTypes.SIMPLE) {
                if (!values.location && !values.usePermanentLocItemAsDestination) {
                    errors.location = this.$t('entity.closeMovement.form.location.emptyError');
                }
            }

            resolve(errors);
        });
    }

    public onBarcodeReaderInput(location: Values['location']) {
        const form = this.$refs.form.form;

        form.batch(() => {
            form.change('location', location);
            form.mutators.setFieldTouched('location', true);
        });
    }

    public onLocationSelected(locationChangeEvent) {
        if (locationChangeEvent.location) {
            this.isLocationSelected = true;
            const form = this.$refs.form.form;

            form.batch(() => {
                form.change('location', locationChangeEvent.location);
                form.mutators.setFieldTouched('location', true);
            });
        } else {
            this.isLocationSelected = false;
        }
    }
}
